import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AllService } from '../../rest/all.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    providers: [AllService]
})

export class NavigationComponent implements AfterViewInit {
    name: string;
    // showHide: boolean;
    userSelected = {
        Id_User: Number,
        Id_Customer: Number,
        Id_Company: Number,
        Id_Language: Number,
        Status: String,
        StatusName: String,
        Name: String,
        Img_Path: String,
        Email: String,
        Date_Add: String,
        Password: String,
        CustomerName: String,
        CompanyName: String
    };
    languajeSelected = 'es';
    // isEs = false;
    // isEn = false;

    gToken = localStorage.getItem('key');
    gLanguaje = localStorage.getItem('languaje');

    urlUserAccount: string = '';

    constructor(private router: Router, private allService: AllService, private translate: TranslateService ) {
        // this.toastr.setRootViewContainerRef(vcr);
        if (localStorage.getItem('languaje') === 'es') {
            translate.use('es');
            this.languajeSelected = 'es';
            // this.isEs = true;
          } else if (localStorage.getItem('languaje') === 'en') {
            translate.use('en');
            this.languajeSelected = 'en';
            // this.isEn = true;
          } else {
            translate.setDefaultLang('es');
            this.languajeSelected = 'es';
            // this.isEs = true;
            localStorage.setItem('languaje', String('es'));
          }
        this.getUserByTokenSerivice();

        let UserToken = localStorage.getItem('key');

        this.urlUserAccount =  environment.LoginURL + 'callback/' +
                            environment.Ambiente + '/' +
                            UserToken + '/' +
                            environment.AppToken;
    }

    getUserByTokenSerivice() {
        this.allService.getUserByToken().subscribe(resp => {
            this.userSelected = resp.data;
        });
    }

    logoutService() {
        this.allService.logout().subscribe(resp => {
            localStorage.setItem('key', '');
            const redirect = '/';
            this.router.navigate([redirect]);
        });
    }

    selectLanguaje() {
        // if (lang === 'es') {
        //   this.isEs = true;
        //   this.isEn = false;
        // } else {
        //   this.isEs = false;
        //   this.isEn = true;
        // }
        localStorage.setItem('languaje', String(this.languajeSelected));
        this.translate.use(this.languajeSelected);
        window.location.reload();
      }

    // changeShowStatus() {
    //     this.showHide = !this.showHide;
    //     localStorage.setItem('menuHide', String(this.showHide));
    // }

    ngAfterViewInit() {

        $(function () {
            $(".preloader").fadeOut();
        });

        var set = function () {
            var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
            var topOffset = 70;
            if (width < 1569) {
                $("body").addClass("mini-sidebar");
                $('.navbar-brand span').hide();
                $(".scroll-sidebar, .slimScrollDiv").css("overflow-x", "visible").parent().css("overflow", "visible");
                $(".sidebartoggler i").addClass("ti-menu");
            } else {
                $("body").removeClass("mini-sidebar");
                $('.navbar-brand span').show();
                $(".sidebartoggler i").removeClass("ti-menu");
            }

            var height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
            height = height - topOffset;
            if (height < 1) height = 1;
            if (height > topOffset) {
                $(".page-wrapper").css("min-height", (height) + "px");
            }

        };
        $(window).ready(set);
        $(window).on("resize", set);

        $(document).on('click', '.mega-dropdown', function (e) {
            e.stopPropagation();
        });

        $(".search-box a, .search-box .app-search .srh-btn").on('click', function () {
            $(".app-search").toggle(200);
        });

        (<any>$('[data-toggle="tooltip"]')).tooltip();

        (<any>$('.scroll-sidebar')).slimScroll({
            position: 'left',
            size: "5px",
            height: '100%',
            color: '#dcdcdc'
        });

        // (<any>$('.right-sidebar')).slimScroll({
        //     height: '100%',
        //     position: 'right',
        //     size: "5px",
        //     color: '#dcdcdc'
        // });

        (<any>$('.message-center')).slimScroll({
            position: 'right',
            size: "5px",
            color: '#dcdcdc'
        });

        $("body").trigger("resize");
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/header-navigation/navigation.component.ts